module.exports = __webpack_public_path__ + "static/media/light.a75632e8.gif";